import { useContext, useEffect } from 'react';
import videojs from 'video.js';
import PropTypes from 'prop-types';
import { MediaContext } from '@playbookux/playbook-web-core';

import './styles.css';

const vjsButton = videojs.getComponent('Button');
const VjsSpacer = videojs.getComponent('Spacer');

class VjsClipButton extends vjsButton {
  createEl(tag = 'button', props = {}, attributes = {}) {
    const el = super.createEl(tag, props, attributes);
    el.innerHTML = this.options().label;
    return el;
  }

  buildCSSClass() {
    return `vjs-create-clip ${super.buildCSSClass()}`;
  }

  handleClick(...args) {
    if (this.options().clickHandler) {
      this.options().clickHandler.call(this, args);
    }
  }
}

const ClipButton = ({ onClick, label }) => {
  const { player } = useContext(MediaContext);

  useEffect(() => {
    const options = {
      beforeElement: 'downloadButton',
      name: 'clipButton',
      clickHandler: onClick,
      label,
    };

    const btn = new VjsClipButton(player, options);
    const clipBtn = player.controlBar.addChild(btn);
    player.controlBar.el()
      .insertBefore(clipBtn.el(), player.controlBar.getChild(options.beforeElement).el());

    const spacerBefore = new VjsSpacer(player);
    const spacerElBefore = player.controlBar.addChild(spacerBefore);
    player.controlBar.el()
      .insertBefore(spacerElBefore.el(), player.controlBar.getChild(options.name).el());

    const spacerAfter = new VjsSpacer(player);
    const spacerElAfter = player.controlBar.addChild(spacerAfter);
    player.controlBar.el()
      .insertBefore(spacerElAfter.el(), player.controlBar.getChild(options.beforeElement).el());

    return () => {
      player.controlBar.removeChild(spacerAfter);
      player.controlBar.removeChild(spacerBefore);
      player.controlBar.removeChild(btn);
    };
  }, [player, label]);

  return null;
};

ClipButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
};

ClipButton.defaultProps = {
  onClick: null,
  label: null,
};

export default ClipButton;
